import React from "react";
import "./Styles.css";
import { FaWhatsapp } from "react-icons/fa";

export default function Tabela() {
  const servicos = [
    { nome: "Formatação Completa", preco: "R$150,00" },
    { nome: "Upgrade de Hardware", preco: "R$200,00" },
    { nome: "Suporte Técnico", preco: "R$120,00" },
    { nome: "Conserto de Hardware", preco: "R$180,00" },
  ];

  return (
    <section className="tabela-section">
      <h2>Tabela de Preços</h2>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Serviço</th>
              <th>Preço</th>
            </tr>
          </thead>
          <tbody>
            {servicos.map((item, idx) => (
              <tr key={idx}>
                <td>{item.nome}</td>
                <td>{item.preco}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Botão WhatsApp corrigido */}
      <a
        href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-action"
      >
        <FaWhatsapp size={20} /> Fale conosco
      </a>
    </section>
  );
}
